import VrrRoutes from './VrrRoutes';

export default VrrRoutes;
